import React from 'react';
import { Table } from 'semantic-ui-react';

import { escribirMonto, imprimirMetodoDePago, imprimirMotivo } from '../utilidades';
import AccionesTablaPagosEventuales from './Componentes/AccionesTablaPagosEventuales';
import { PagoEventual } from './tipos';

interface TablaPagosEventualesProps {
    readonly datos: ReadonlyArray<PagoEventual>;
    idPlanDePago: string;
    alEditarPago(): void;
}

interface State {
    //
}
export class TablaPagosEventuales extends React.Component<TablaPagosEventualesProps, State> {
    public render() {
        const { idPlanDePago, datos, alEditarPago } = this.props;
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Motivo
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Monto
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Fecha del pago
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Método de pago
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={1}>
                                Interés
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Nº boleta
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={2}>
                                Observaciones
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign='center' width={1} />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {datos.map(x => (
                            <Table.Row key={x.fechaDeRegistroDelPago}>
                                <Table.Cell textAlign='center' width={2}>
                                    {x.motivo !== 'otro' ? imprimirMotivo(x.motivo) : x.otroMotivo}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={2}>
                                    {escribirMonto(x.monto)}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={2}>
                                    {x.fecha}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={2}>
                                    {imprimirMetodoDePago(x.idMetodoDePago)}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={1}>
                                    {escribirMonto(x.interes)}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={2}>
                                    {x.numeroDeBoleta}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={2}>
                                    {x.observaciones}
                                </Table.Cell>
                                <Table.Cell textAlign='center' width={1}>
                                    <AccionesTablaPagosEventuales
                                        idPlanDePago={idPlanDePago}
                                        pago={x}
                                        alEditarPago={alEditarPago}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default TablaPagosEventuales;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/TablaPagosEventuales.tsx